import styled from 'styled-components';

export const FormsListContainer = styled.div`
	display: flex;
	position: relative;
	flex-wrap: wrap;
	margin: 0 -2rem;
`;
